import React from 'react'
import { Skeleton, Space, Typography } from 'antd'
import PropTypes from 'prop-types'
import CategoryChoiceMessageSkeleton from './CategoryChoiceMessageSkeleton'

const { Text } = Typography

export const THINKING_STATES = {
    PROCESSING: 'processing',    // General state for any processing
    INITIALIZING: 'initializing' // Keep this separate as it's used for initial setup
}

const THINKING_MESSAGES = {
    [THINKING_STATES.PROCESSING]: "Processing your input and preparing the next item...",
    [THINKING_STATES.INITIALIZING]: "Initializing the refinement process. This may take a few minutes. You can come back later when it's ready..."
}

const DEFAULT_SKELETON = (
    <Skeleton 
        active 
        paragraph={{ rows: 4, width: ['60%', '80%', '40%', '70%'] }}
        title={false}
    />
)

const THINKING_SKELETONS = {
    [THINKING_STATES.PROCESSING]: <CategoryChoiceMessageSkeleton />
}

const ThinkingMessage = ({ content }) => {
    const state = content?.state || THINKING_STATES.PROCESSING

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Text type="secondary">{THINKING_MESSAGES[state]}</Text>
            {THINKING_SKELETONS[state] || DEFAULT_SKELETON}
        </Space>
    )
}

ThinkingMessage.propTypes = {
    content: PropTypes.shape({
        state: PropTypes.oneOf(Object.values(THINKING_STATES))
    })
}

export default ThinkingMessage 